<template>
  <div class="kye-multiple-dept-dialog-body">
    <div :class="{'kye-multiple-dept-dialog-body-tree': showPanel}">
      <div v-if="showPanel" class="kye-multiple-dept-dialog-body-title">
        <span class="kye-multiple-dept-dialog-body-title-text">组织树</span>
      </div>
      <div :class="{'pd-16': showPanel}">
      <inputSearch
        ref="inputSearch"
        :historyId="historyId"
        :inputSearchUrl="inputSearchUrl"
        :searchDepartmentParams="searchDepartmentParams"
        :formatResult="formatResult"
        @chooseDepartment="chooseDepartment"
      ></inputSearch>
      <dept-tree
        v-loading="load"
        ref="deptTree"
        :checkStrictly="checkStrictly"
        :authTree="authTree"
        :load="load"
        :init="init"
        :accordion="accordion"
        :defaultCheckedKeys="defaultCheckedKeys"
        :defaultExpandedKeys="defaultExpandedKeys"
        :ids="ids"
        :orgTreeDeptMap="orgTreeDeptMap"
        :orgTreeDeptData="orgTreeDeptData"
        :setCurrentNode="setCurrentNode"
        :searchCheckedNode="searchCheckedNode"
        @getCheckedNodeList="getCheckedNodeList"
        @current-node-change="currentNodeChange"
      >
        <template slot="treeLabel" slot-scope="{node,data,checkedMapDept}">
          <slot name="treeLabel" :node='node' :data='data' :checkedMapDept="checkedMapDept">{{node.label}}</slot>
        </template>
      </dept-tree>
      </div>
    </div>
    <checked-dept-panel
      v-if="showPanel"
      :checkedNodes="checkedNodeList"
      :deptMap="orgTreeDeptMap"
      @deleteAllChecked="deleteAllChecked"
      @handleDeleteCheckedNode="handleDeleteCheckedNode"
    ></checked-dept-panel>
  </div>
</template>

<script>
  import deptApi from 'public/utils/dept-api'
  import {
    mapDepts,
  } from '../../query-table/utils'
  import checkedDeptPanel from './checked-dept-panel.vue'
  import deptTree from './dept-tree.vue'
  import inputSearch from './input-search.vue'
  export default {
    name: 'KyeDeptMultiple',
    components: { checkedDeptPanel, deptTree, inputSearch },
    props: {
      model: Object,
      load: {
        type: Boolean,
        default: false
      },
      searchCheckedNode: { // 模糊搜索匹配后是否直接选中
        type: Boolean,
        default: false
      },
      init: {
        type: Boolean,
        default: false
      },
      accordion: { // 是否每次只打开一个同级树节点展开
        type: Boolean,
        default: true
      },
      setCurrentNode: { // 复选框change之前的回调，返回true,则允许执行之后的内部逻辑，反之阻止
        type: Function
      },
      fetchData: Function,
      searchUrl: { // 搜索接口url
        type: String,
      },
      searchParams: { // 搜索接口url参数
        type: Function,
      },
      deptSearchResultUrl: { // 搜索结果的url
        type: String,
      },
      formatResult: { // 过滤搜索结果的方法。
        type: Function
      },
      showPanel: { // 是否开启右侧的已选择面板
        type: Boolean,
        default: false
      },
      checkStrictly: { // 是否不联动，true则不联动，反之
        type: Boolean,
        default: false
      },
      defaultCheckedKeys: { // 默认勾选的节点ID
        type: Array,
        default: () => ([])
      },
      hasAllTree: {
        type: Boolean,
        default: false
      },
      historyId: String // 配合输入框的历史记录功能, 实现xPath不能区分节点, 添加指定的historyId确认唯一性
    },
    data () {
      return {
        orgTree: {},
        authTree: [],
        ids: [],
        checkedNodeList: [],
        deptMap: {
          deptMap: {},
          data: {}
        },
        customDeptTree: {}
      }
    },
    computed: {
      threeLevelTreeUrl () {
        const deptSearchResultUrl = this.deptSearchResultUrl
        const url = deptSearchResultUrl || 'hr.department.refactoring.getThreeLevelAsTree'
        return this.bakMonth ? 'hr.departmentBak.getThreeLevelAsTree' : url
      },
      bakMonthLabel () {
        return this.bakMonth ? `历史数据：${this.bakMonth}` : '实时数据'
      },
      // 默认展开3级节点。
      defaultExpandedKeys () {
        const [row] = this.authTree || []
        const { id } = row || {}
        const { departmentId } = (this.$refs.inputSearch && this.$refs.inputSearch.form) || {}
        const ids = [...new Set([id, departmentId, ...this.defaultCheckedKeys])].filter(x => x)
        return ids
      },
      // // 缓存的树数据-包含平铺节点
      // orgTree () {
      //   return this.$store.state.orgTree || {}
      // },
      // 输入框的url 区分自定义与历史
      inputSearchUrl () {
        const url = this.searchUrl
        return url || (this.bakMonth ? 'hr.departmentBak.getByFuzzyValue' : 'hr.department.refactoring.getByFuzzyValue')
      },
      // 平铺的节点
      orgTreeDeptMap() {
        return (this.fetchData ? this.customDeptTree.deptMap : this.orgTree.deptMap) || {}
      },
      orgTreeDeptData() {
        return (this.fetchData ? this.customDeptTree.data : this.orgTree.data) || {}
      }
    },
    created () {
      deptApi.getAllOrgTreeData(true).then(async data => {
        this.orgTree = {
          data,
          deptMap: await deptApi.getAllOrgMap()
        }
      })
    },
    methods: {
      setSearchCheckedNode (id) {
        const deptTreeInstance = this.$refs.deptTree
        // 选中的节点状态 强制处理为勾选
        deptTreeInstance.setSomeCheckedMapDept(id)
        deptTreeInstance.setIdsNodeStatus([id])
      },
      processChoosedNode (id, data) {
        const deptTreeInstance = this.$refs.deptTree
        // 搜索后子节点的情况处理
        deptTreeInstance.choosedSetChildrenStatus(id)
        // 选中的节点状态 强制处理为勾选
        deptTreeInstance.handleCheckChange(data, false, true)
      },
      // 输入框选中的回调
      async chooseDepartment (item) {
        const deptTreeInstance = this.$refs.deptTree
        if (item) {
          let id = item.id
          const data = this.orgTreeDeptMap[id]
          if (!data) {
            return
          }
          this.ids = [id]
          this.$emit('chooseDepartment')
          if (this.hasAllTree) { // 仅在当前的树中去定位
            this.$nextTick(() => {
              deptTreeInstance.$refs.tree.filter(id)
              if (this.searchCheckedNode) {
                this.setSearchCheckedNode(id)
                this.processChoosedNode(id, data)
              }
            })
          } else {
            await this.filterTree(id).then(e => {
              this.$nextTick(() => {
                if (this.searchCheckedNode) {
                  this.setSearchCheckedNode(id)
                }
                this.processChoosedNode(id, data)
              })
            })
          }
        }
      },
      // 搜索部门的回调
      searchDepartmentParams (val) {
        if (this.searchParams && typeof this.searchParams === 'function') {
          return this.searchParams(val)
        }
        return this.bakMonth ? { fuzzyValue: val, bakMonth: this.bakMonth } : { fuzzyValue: val }
      },
      // 根据搜索的id查询三级组织
      async filterTree (id) {
        let params = this.bakMonth ? { id, bakMonth: this.bakMonth } : { id }
        await this.$http(this.threeLevelTreeUrl, params).then(this.initData)
      },
      // 处理树数据，判断是否为数组，重置树数据以及平铺的数据
      initData (data, all) {
        const isArray = Array.isArray(data)
        const Root = {
          id: 'root',
          children: data
        }
        if (all) {
          this.deptMap = this.orgTree.deptMap || {}
          this.authTree = isArray ? [...data] : [data]
        } else {
          if (isArray) {
            // 如果是数组则需要本地模拟顶层节点
            this.deptMap = mapDepts({}, Root, Root.children)
            this.authTree = [...data]
          } else {
            this.deptMap = mapDepts({}, data, data.children)
            this.authTree = [data]
          }
        }
        // 如果是fetchData则需要不能取store里面的数据，防止数据错误
        if (this.fetchData) {
          let obj = { data: isArray ? Root : data, deptMap: this.deptMap }
          this.customDeptTree = obj
        }
      },
      // 勾选默认选中的节点
      setCheckedKeys (data) {
        this.$refs.deptTree.setCheckedKeys(data)
      },
      // 获取节点
      getCheckedNodes () {
        return this.checkedNodeList.map(item => this.deptMap[item])
      },
      // 删除某个选中的组织
      handleDeleteCheckedNode (id) {
        // 模拟取消勾选的效果
        let data = this.orgTreeDeptMap[id]
        data && this.$refs.deptTree.handleCheckChange(data)
        this.$emit('deleteCheckedNode', id, data)
      },
      // 清空所有节点
      async deleteAllChecked() {
        if (!this.checkedNodeList.length) {
          return
        }
        await this.$confirm(`是否删除所有已选组织数据？`, '提示')
        this.$emit('deleteAllCheckedNode')
        this.$refs.deptTree.deleteRootStatusOfLinked()
      },
      getCheckedNodeList (checkedNodeList) {
        this.checkedNodeList = checkedNodeList
        this.$emit('getCheckedNodeList', checkedNodeList)
      },
      currentNodeChange (data) {
        this.$emit('current-node-change', data)
      }
    }
  }
</script>

<style lang="less">
.kye-multiple-dept-dialog-body {
  .pd-16 {
    padding: 0 16px;
  }
  display: flex;
  &-title {
    padding: 16px;
    border-bottom: 1px solid #e9e8ed;
    margin-bottom: 16px;
    &-text {
      font-size: 14px;
      font-weight: bold;
      text-align: left;
      color: #333333;
      line-height: 14px;
      >span {
        color: var(--g-color-primary);
      }
    }
  }
  &-tree {
    width: 400px;
    border: 1px solid #e9e8ed;
    border-radius: 4px;
  }
  .el-tree-node__content {
    .el-checkbox {
      display: none;
    }
    .custom-tree-node {
      display: flex;
      align-items: center;
      font-size: 12px;
      .el-checkbox {
        display: block;
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept-multiple/components/tree-body.vue